export function getInitialOptions(options) {
    return options.map(({ value, label }) => ({
        id: value,
        label,
        checked: false,
    }));
}
export function getCheckedOptions(options) {
    return options
        .filter((option) => option.checked)
        .map(({ id, label }) => ({
        value: id,
        label,
    }));
}
